import { render, staticRenderFns } from "./productListing.vue?vue&type=template&id=2f07aac3&scoped=true&"
import script from "./productListing.vue?vue&type=script&lang=js&"
export * from "./productListing.vue?vue&type=script&lang=js&"
import style0 from "./productListing.vue?vue&type=style&index=0&id=2f07aac3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07aac3",
  null
  
)

export default component.exports